import { language } from '../utils/language';
import convertArrToObj from '../utils/convertArrToObj';

export const HOUSEHOLDER = 'HOUSEHOLDER';
export const CO_HOUSEHOLDER = 'CO_HOUSEHOLDER';
export const RENTER = 'RENTER';
export const MEMBER = 'MEMBER';
export const EMPOWER = 'EMPOWER';

export const RESIDENT_STATUS_ALL = '';
export const RESIDENT_STATUS_ACTIVE = 'ACTIVE';
export const RESIDENT_STATUS_DISABLED = 'DISABLED';

export const RESIDENT_ROLES = [
  { id: HOUSEHOLDER, name: language.label.householder },
  { id: CO_HOUSEHOLDER, name: language.label.co_householder },
  { id: RENTER, name: language.label.renter },
  { id: MEMBER, name: language.label.member },
  { id: EMPOWER, name: language.empower },
];

export const RESIDENT_ROLES_BY_NAME = RESIDENT_ROLES.map((role) => role.name);

export const RESIDENT_ROLE_BY_ID = convertArrToObj(RESIDENT_ROLES, 'id');

export const RESIDENT_STATUS_USED_APP_ALL = '';
export const RESIDENT_STATUS_USED_APP_ACTIVE = 'ACTIVE';
export const RESIDENT_STATUS_USED_APP_INACTIVE = 'INACTIVE';
export const RESIDENT_STATUS_USED_APP_NOT_INSTALLED_APP = 'NOT_USE';

export const RESIDENT_STATUS_USED_APP_OPTIONS = [
  {
    id: RESIDENT_STATUS_USED_APP_ALL,
    name: language.all_status_used_app,
  },
  {
    id: RESIDENT_STATUS_USED_APP_ACTIVE,
    name: language.active,
  },
  {
    id: RESIDENT_STATUS_USED_APP_INACTIVE,
    name: language.inactive,
  },
  {
    id: RESIDENT_STATUS_USED_APP_NOT_INSTALLED_APP,
    name: language.not_installed_app,
  },
];

export const AGE_RANGE_OPTIONS = [
  {
    id: '1,6',
    name: language.label.from_1_to_6,
  },
  {
    id: '6,10',
    name: language.label.from_6_to_10,
  },
  {
    id: '10,20',
    name: language.label.from_10_to_20,
  },
  {
    id: '20,60',
    name: language.label.from_20_to_60,
  },
  {
    id: '60,1000',
    name: language.label.greater_than_60,
  },
];

export const RESIDENT_STATUS_OPTIONS = [
  {
    id: RESIDENT_STATUS_ALL,
    name: language.all,
  },
  {
    id: RESIDENT_STATUS_ACTIVE,
    name: language.active,
  },
  {
    id: RESIDENT_STATUS_DISABLED,
    name: language.deleted,
  },
];

export const RESIDENT_CONFIRM_POLICY_SOURCE_APP = 'APP';
export const RESIDENT_CONFIRM_POLICY_SOURCE_WEB = 'FILE_UPLOAD';

export const RESIDENT_CONFIRM_POLICY_SOURCE_OPTIONS = [
  {
    id: RESIDENT_CONFIRM_POLICY_SOURCE_APP,
    name: language.resident_app,
  },
  {
    id: RESIDENT_CONFIRM_POLICY_SOURCE_WEB,
    name: language.file_upload,
  },
];

export const RESIDENT_CONFIRM_POLICY_SOURCE_BY_ID = convertArrToObj(RESIDENT_CONFIRM_POLICY_SOURCE_OPTIONS, 'id');

export const CONFIRMED_POLICY_OPTIONS = [
  {
    id: '',
    name: language.all,
  },
  {
    id: 'true',
    name: language.agreed,
  },
  {
    id: 'false',
    name: language.not_agreed,
  },
];

export const INVOICE_ISSUER_TYPE_INDIVIDUAL = 'INDIVIDUAL';
export const INVOICE_ISSUER_TYPE_COMPANY = 'COMPANY';

export const INVOICE_ISSUER_TYPE = [
  { id: INVOICE_ISSUER_TYPE_INDIVIDUAL, name: language.invoice_issuer_individual },
  { id: INVOICE_ISSUER_TYPE_COMPANY, name: language.invoice_issuer_company },
];

export const RESIDENT_DEFAULT_FILTER = {
  role: '',
  status: RESIDENT_STATUS_ACTIVE,
  name: '',
  apartment: '',
  phone: '',
  secondaryPhone: '',
  email: '',
  secondaryEmail: '',
  gender: '',
  age: '',
  monthOfBirth: '',
  appStatus: RESIDENT_STATUS_USED_APP_ALL,
  isConfirmedPolicy: '',
};
